<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Program Management</h1>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="form-group d-flex justify-content-end mb-3">
                            <div class="text-right text-nowrap">

                                <button type="button" routerLink="/add-program" class="btn btn-info link font17"
                                    style="height: 35px;padding-top: 3px;">
                                    <i class="fa fa-plus-circle" aria-hidden="true"> Add New </i>
                                </button>
                                <!-- <a class="link font17"><i class="fas fa-plus-circle me-1"></i> Add Sub Admin</a> -->
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered" aria-describedby="">
                                <thead>
                                    <tr class="no_wrap_th text-center">
                                        <th class="Sorting-img" scope="col">S.No.</th>
                                        <th scope="col" class="Sorting-img">Program name</th>
                                        <th scope="col" class="Sorting-img">Type</th>
                                        <th scope="col" class="Sorting-img">Program Amount($)</th>
                                        <th scope="col" class="Sorting-img">Description</th>
                                        <th scope="col" class="action_td_btn3 Sorting-img">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of programList | paginate: { itemsPerPage: itemPerPage, currentPage: currentPage, totalItems: total }; track item?._id; let i = $index ) {
                                    <tr class="text-center">
                                        <td>{{ itemPerPage * (currentPage - 1) + i + 1 }}</td>

                                        <td class="content">
                                            <abbr [title]="item?.title">{{ item?.title || '--' }}</abbr>
                                        </td>

                                        <td class="content">
                                            <abbr [title]="item?.programType">{{ item?.programType || '--' }}</abbr>
                                        </td>

                                        <td class="content">${{ item?.amount || '--' }}</td>

                                        <td class="content" [innerHTML]="item?.update_des">
                                            <abbr [title]="item?.update_des">{{ item?.update_des || '--' }}</abbr>
                                        </td>

                                        <td class="text-center action_td">
                                            <button class="btn btn-info ms-2 bt-margin"
                                                [routerLink]="['/edit-program/', item._id]">
                                                <i class="fa fa-edit" style="color:white"></i>
                                            </button>

                                            <button class="btn btn-danger ms-2 bt-margin" title="delete"
                                                (click)="deleteUserModal(item._id)">
                                                <i class="fa fa-trash" style="color:white"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    }

                                    @if(!programList.length){
                                    <tr>
                                        <td class="table-no-record" colspan="6">No Record Found</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            @if(total > 10){
                            <div class="custom-pagination my-3 d-flex justify-content-end">
                                <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- delete hospital modal Start -->
<div class="modal fade global-modal reset-modal" id="deleteUser">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete Program</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to delete this Program?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" (click)="deleteProgram()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- end delete hospital modal -->